<template>
  <el-form
    :model="editForm"
    ref="editForm"
    :rules="rules"
    label-width="100px"
    :hide-required-asterisk="false"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-row>
      <el-col :span="24">
        <el-row>
          <el-col :span="24">
            <el-tabs v-model="activeEditor" @tab-click="handleClickTabs">
              <el-tab-pane label="详细描述" name="0">
                <span>
                  <div id="wangEditor"></div>
                </span>
              </el-tab-pane>
              <el-tab-pane label="解决方案" name="1">
                <span>
                  <div id="wangEditor2"></div>
                </span>
              </el-tab-pane>
            </el-tabs>
          </el-col>

          <el-col style="line-height: 40px">信息确认</el-col>
          <el-col :span="24" style="margin-top: 15px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="问题分类" prop="sort">
                  <el-select
                    v-model="editForm.sort"
                    filterable
                    default-first-option
                    style="width: 100%"
                    placeholder="请选择问题分类"
                  >
                    <el-option
                      v-for="item in sortList"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="严重程度" prop="questionLevel">
                  <el-select
                    v-model="editForm.questionLevel"
                    filterable
                    default-first-option
                    style="width: 100%"
                    placeholder="请选择严重程度"
                  >
                    <el-option
                      v-for="item in yzcdList"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="截至时间" prop="endTime">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="editForm.endTime"
                    :picker-options="pickerOptions"
                    style="width: 100%"
                    :clearable="false"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="版本" prop="productVersion">
                  <el-input
                    show-word-limit
                    placeholder="如：V1.6.3"
                    maxlength="20"
                    v-model="editForm.productVersion"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="影响版本" prop="influenceVersion">
                  <el-input
                    show-word-limit
                    placeholder="如：V1.6.3"
                    maxlength="40"
                    v-model="editForm.influenceVersion"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="所属模块" prop="module">
                  <el-input
                    show-word-limit
                    placeholder="如：业绩预约"
                    v-model="editForm.module"
                    maxlength="30"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="解决方案" prop="isSolve">
                  <el-select
                    v-model="editForm.isSolve"
                    style="width: 100%"
                    placeholder="请选择解决方案"
                  >
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      v-for="item in isSolveList"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <span v-if="!editForm.isSolve">
                <el-col :span="8">
                  <el-form-item
                    label="现指派给"
                    prop="designee"
                    class="designee"
                  >
                    <treeselect
                      v-model="editForm.designee"
                      placeholder="请选择员工"
                      :options="deptUser"
                      :disable-branch-nodes="true"
                      :show-count="true"
                      value-consists-of="LEAF_PRIORITY"
                      no-results-text="未搜到任何结果"
                      :normalizer="normalizer"
                      style="width: 100%"
                      size="small"
                      @select="handleChangeYg"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="指派说明" prop="content">
                    <el-input
                      placeholder="请输入内容"
                      v-model="editForm.content"
                      maxlength="200"
                    >
                      <template slot="append">
                        <div @click="zpsmDialog = true">更多</div>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </span>
            </el-row>
          </el-col>
          <el-col style="line-height: 40px">附件</el-col>
          <el-col :span="24" style="margin-top: 15px">
            <el-row>
              <el-col :span="8">
                <!-- <el-form-item key="12"> -->
                <el-upload
                  action="#"
                  class="upload-demo"
                  ref="upload"
                  :headers="headers"
                  :on-change="handleChange"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  :auto-upload="false"
                  multiple
                  :limit="5"
                >
                  <el-button type="primary" icon="el-icon-upload" plain
                    >选择附件</el-button
                  >
                </el-upload>
                <!-- </el-form-item> -->
              </el-col>
              <el-col :span="16" style="line-height: 40px">
                <div>(单个文件不能超过50M，支持所有扩展名)</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <!-- <el-form-item label=""> -->
            <el-table
              :data="editForm.file"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="文件名称"
                align="left"
                prop="filename"
                min-width="250px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <el-link @click="openPreview(scope.row)" type="primary">
                    {{ scope.row.filename }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column
                label="上传时间"
                align="left"
                prop="uploadtime"
                min-width="200px"
                :show-overflow-tooltip="true"
              />

              <el-table-column
                label="上传阶段"
                align="left"
                prop="fileSize"
                min-width="200px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.xm }}{{ scope.row.remark }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="left"
                min-width="100px"
                :show-overflow-tooltip="true"
                fixed
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="handleDownloadFile(scope.row)"
                    >下载</el-button
                  >
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
            <!-- </el-form-item> -->
          </el-col>
          <el-col
            style="
              line-height: 40px;
              display: flex;
              margin: 15px 0;
              justify-content: space-between;
            "
          >
            <div>
              <span style="font-weight: 700; font-size: 16px">评论</span>
              共{{ editForm.pinglun.length }}条评论
            </div>
            <el-button type="primary" @click="handleAddComment">评论</el-button>
          </el-col>
          <el-col :span="24">
            <span>
              <div id="wangEditor3"></div>
            </span>
          </el-col>
          <el-col>
            <div
              v-for="item in editForm.pinglun"
              :key="item.id"
              class="zpsm-comment-item"
            >
              <div class="top">
                <div>{{ item.username ? item.username[0] : "" }}</div>
                <div>{{ item.username }}</div>
              </div>
              <div class="middle">
                <span
                  v-for="(picItem, picIndex) in item.commnetSlice"
                  :key="picIndex"
                >
                  <span v-if="picItem && picItem.picBig">
                    <span>
                      <el-image
                        style="max-width: 200px"
                        :src="picItem.srcBig"
                        :preview-src-list="[picItem.srcBig]"
                      >
                      </el-image>
                    </span>
                  </span>
                  <span v-else v-html="picItem"></span>
                </span>
              </div>
              <div class="bottom">{{ item.create_time }}</div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="指派说明"
      :visible.sync="zpsmDialog"
      width="90%"
      v-if="zpsmDialog"
      id="mx-dialog"
      append-to-body
    >
      <div>
        <!-- <el-input
          type="textarea"
          placeholder="请输入指派说明"
          :rows="5"
          maxlength="100"
          show-word-limit
          v-model="zpsmDetail.zpsm"
        ></el-input>-->
      </div>
      <div class="comment">
        <div
          class="zpsm-comment-item"
          v-for="(item, index) of editForm.designeeList"
          :key="index"
        >
          <div class="top">
            <div>{{ item.createby[0] }}</div>
            <div>{{ item.createby }}</div>
            <div>
              <img src="@/img/zhipai.svg" alt />
            </div>
            <div>{{ item.designee }}</div>
          </div>
          <div class="middle">{{ item.content }}</div>

          <div class="bottom">{{ item.create_time }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="zpsmDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  formatMomentDate,
  checkVal,
  cutContent,
  getPicList,
} from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";

import {
  getDictData,
  submitUpload,
  getQuestionDetail,
  saveComment,
  confirmQuestion,
  uploadFile,
} from "@/api/question.js";
import { getXmxxList } from "@/api/itWeekly";

import { fetchQuestionTx } from "@/api/common.js";
import checkVue from "./check.vue";
export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "question"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      form: {
        rldxActive: 1,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      fileList: [],
      rules: {
        sort: [
          { required: true, message: "问题分类不能为空", trigger: "change" },
        ],
        questionLevel: [
          {
            required: true,
            message: "严重程度不能为空",
            trigger: "change",
          },
        ],
        endTime: [
          {
            required: true,
            message: "截至时间不能为空",
            trigger: "change",
          },
        ],
        isSolve: [
          { required: true, message: "解决方案不能为空", trigger: "change" },
        ],
        designee: [
          { required: true, message: "指派人不能为空", trigger: "change" },
        ],
        // productVersion: [
        //   { required: true, message: "版本不能为空", trigger: "change" },
        // ],
      },
      editForm: {
        title: null,
        status: null,
        sort: null,
        questionLevel: null,
        line: null,
        xmbh: null,
        productVersion: null,
        module: null,
        influenceVersion: null,
        designee: null,
        content: null,
        finishTime: "",
        planTime: null,
        detail: null,
        jjfa: null,
        fileIds: null,
        designeeName: null,
        pinglun: [],
        endTime: null,
      },

      txList: [],
      xmList: [],
      sortList: [],
      sortList2: [],
      bmList: [],
      statusList: [],
      yzcdList: [],
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "0", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "0",
        //htzt: "1,2,3,4,5", //合同状态，多个,隔开，如1,3
      },
      activeEditor: "0",
      zpsmDialog: false,
      parentDialog: false,
      isSolveList: [
        { label: "无", value: 0 },
        { label: "有", value: 1 },
      ],

      fullscreenLoading: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    fetchQuestionTx().then((res) => {
      if (res.code == 0) {
        this.txList = res.data;
      }
    });
    getXmxxList(
      this.data2.htlx,
      this.data2.range,
      this.data2.htzt,
      "",
      ""
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
    getDictData("pmp_quality_sort", 1).then((res) => {
      if (res.code === 0) {
        this.sortList = res.data;
        this.sortList2 = res.data;
      }
    });
    getDictData("pmp_quality_status", 1).then((res) => {
      if (res.code === 0) {
        this.statusList = res.data;
      }
    });
    getDictData("pmp_quality_type", 1).then((res) => {
      if (res.code === 0) {
        this.yzcdList = res.data;
      }
    });
    this.getData();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    let editor2 = new wangEditor(`#wangEditor2`);
    let editor3 = new wangEditor(`#wangEditor3`);

    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    editor3 = this.editorConfig(editor3, 150);

    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;
    this.editor3 = editor3;
  },
  methods: {
    getData(isComment) {
      getQuestionDetail({ id: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          if (res.data.line == 1 || res.data.line == 2 || res.data.line == 4) {
            this.sortList = this.sortList2.filter((o) => o.dictValue > 20);
            if (this.editForm.sort < 20) {
              this.editForm.sort = null;
            }
          } else {
            this.sortList = this.sortList2.filter((o) => o.dictValue < 20);
            if (this.editForm.sort > 20) {
              this.editForm.sort = null;
            }
          }
          if (isComment) {
            this.editForm.pinglun = res.data.pinglun;
          } else {
            this.editForm = res.data;
            this.editor.txt.html(this.editForm.detail);
            this.editor2.txt.html(this.editForm.jjfa);
            if (this.editForm.finishTime) {
              this.editForm.finishTime = moment(this.editForm.finishTime + "");
              this.editForm.endTime = this.editForm.finishTime;
            }
            if (!this.editForm.isSolve) {
              this.editForm.isSolve = 0;
            }
          }
          if (this.editForm.pinglun && this.editForm.pinglun.length > 0) {
            for (let i in this.editForm.pinglun) {
              const picList = getPicList(this.editForm.pinglun[i].content);
              this.editForm.pinglun[i].commnetSlice = cutContent(
                picList,
                this.editForm.pinglun[i].content
              );
            }
          }
        }
      });
    },
    editorConfig(editor, height) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = height ? height : 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中

      editor.create();
      return editor;
    },
    fetchName(key, arr) {
      for (let i of arr) {
        if (key == i.dictValue) {
          return i.dictLabel;
        }
      }
      return null;
    },
    saveForm() {
      let endTime = null;
      let sortName = this.fetchName(this.editForm.sort, this.sortList);
      let questionLevelName = this.fetchName(
        this.editForm.questionLevel,
        this.yzcdList
      );
      let lineName = this.fetchName(this.editForm.line, this.txList);
      let xmmc = null;
      for (let i = 0; i < this.xmList.length; i++) {
        if (this.editForm.xmbh == this.xmList[i].xmbh) {
          xmmc = this.xmList[i].xmjc;
        }
      }
      if (this.editForm.endTime) {
        endTime = formatMomentDate(new Date(this.editForm.endTime));
      }

      const params = {
        ...this.editForm,
        endTime,
        sortName,
        questionLevelName,
        lineName,
        xmmc,
        status: "2",
        statusName: "已确认",
      };
      if (this.editor3.txt.html()) {
        saveComment({
          id: this.mxParams.id,
          status: this.editForm.status,
          content: this.editor3.txt.html(),
        });
      }
      confirmQuestion(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "question/fetchQuestionListAction",
            this.question.questionList.params
          );
          this.fullscreenLoading = false;
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetFrom() {
      this.editForm = {
        ...this.editForm,
        ...{
          jf: null,
          title: null,
          rldx: 1,
          ygbhs: null,
          bmbhs: null,
          txlxs: null,
          rwsm: null,
          yqjg: null,
          jsrq: null,
          gs: 0,
          rwmb: null,
          bz: null,
        },
      };
      this.editor.txt.html("");
      this.editor2.txt.html("");
      this.form.rldxActive = 0;
    },
    handleChange(file, fileList) {
      //验证上传文件的格式
      // const suffixReg = /(xls|xlsx|pdf|doc|docx|ppt|pptx)$/;
      // const point = file.name.lastIndexOf(".");
      // const suffix = file.name.substr(point + 1);
      // const isFile = suffixReg.test(suffix);
      // if (!isFile) {
      //   this.$message.error("请上传正确格式的文件 !");
      //   fileList.pop();
      //   return false;
      // }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
      //验证上传文件重复
      // let existFile = fileList
      //   .slice(0, fileList.length - 1)
      //   .find((f) => f.name === file.name);
      // if (existFile) {
      //   this.$message.error("当前文件已经存在!");
      //   fileList.pop();
      //   return false;
      // }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload(status) {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.editForm.detail = this.editor.txt.html();
          this.editForm.jjfa = this.editor2.txt.html();
          if (!this.editForm.detail) {
            this.$message.error("请输入详细描述！");
            return;
          }
          if (!this.editForm.designee) {
            this.$message.error("请输入被指派人！");
            return;
          }
          this.fullscreenLoading = true;
          this.$refs.upload.submit();
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });

          if (fileLen > 0) {
            //上传文件
            form.append("id", this.mxParams.id);
            form.append("type", "确认");
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.editForm.fileIds = success.data;
                this.saveForm(status);
              }
            });
          } else if (fileLen == 0) {
            this.saveForm(status);
          } else {
            this.$message.error(res.msg);
            return false;
          }
        } else {
          this.hiddenDialog(true);
        }
      });
    },
    handleDeleteFile(row) {
      deleteFile({ fileId: row.fileId, path: row.url }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDownloadFile(row) {
      const filePath = row.absolutepath;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },

    giveFather() {
      this.parentDialog = false;
    },
    openPreview(row) {
      const url = row.url;
      window.open(url);
    },
    handleClickTabs(e) {
      this.activeEditor = e.index;
    },
    handleAddComment() {
      const params = {
        id: this.mxParams.id,
        status: this.editForm.status,
        content: this.editor3.txt.html(),
      };

      if (!params.content || checkVal(params.content)) {
        return;
      }
      saveComment(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.editor3.txt.html("");
          this.getData(true);
        }
      });
    },
    handleChangeYg(e) {
      this.editForm.designeeName = e.xm;
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.r {
  margin: 0 10px;
  .r_title {
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #e4e7ed;
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 15px;
  }
}
.zpsm-comment-item {
  margin-top: 15px;
  .top {
    display: flex;
    line-height: 30px;
    font-weight: bold;
    font-size: 15px;
    > div {
      margin-right: 15px;
    }
    > div:nth-of-type(1) {
      background-color: #8080ff;
      color: #fff;
      height: 30px;
      line-height: 30px;
      width: 30px;
      text-align: center;
      border-radius: 50%;
    }
  }
  .middle {
    line-height: 20px;
    color: #555;
    padding-left: 45px;
    margin: 10px 0;
  }
  .bottom {
    font-size: 12px;
    padding-left: 45px;
    color: #7f7f7f;
  }
}
</style>